import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ApplicationInsightsService } from '@stockcare-services/application-insights/application-insights.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private appConfig;
  configLoaded = new BehaviorSubject(false);
  constructor(private http: HttpClient) {}

  initialize() {
    console.log('Loading config');
    this.http
      .get('assets/data/app-config.json')
      .toPromise()
      .then((data) => {
        this.appConfig = data;
        this.configLoaded.next(true);
      });
  }

  get config() {
    return this.appConfig;
  }
}
